import classNames from 'classnames';
import Icons from 'components/icons';
import Text from 'components/ui/Text';
import { useTranslation } from 'hooks/useTranslation';
import { forwardRef } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectUiState, setUi } from 'store/uiSlice';

type MarkerTooltipType = {
  ref: HTMLDivElement;
};

// const MarkerTooltip: FC<MarkerTooltipType> = (props) => {
const MarkerTooltipFooter = ({ tooltip }: { tooltip?: any }) => {
  const dispatch = useAppDispatch();
  const translation = useTranslation();
  const ui = useAppSelector(selectUiState) || {};

  return (
    <div className="flex flex-row gap-6 justify-between px-0">
      <a
        className="text-link small-caps text-medium2 leading-none"
        // onClick={() => {
        //   dispatch(
        //     setUi({
        //       dashboard: {
        //         tooltip: undefined,
        //       },
        //     }),
        //   );
        // }}
        onClick={() => {
          dispatch(
            setUi({
              ...ui,
              tooltip: undefined,
              dashboard: {
                ...ui.dashboard,
              },
            }),
          );
        }}
      >
        {translation('onboarding.gotIt')}
      </a>

      <a
        className="text-link text-medium2 leading-none small-caps text-gray-500 flex gap-2 justify-between items-center group"
        onClick={() => {
          dispatch(
            setUi({
              ...ui,
              tooltip: undefined,
              dashboard: {
                ...ui.dashboard,
                lightingKnowledge: {
                  status: 'open',
                  sectionId: tooltip?.ligtingSolutionSectionId,
                },
              },
            }),
          );
        }}
      >
        {translation('general.learnMore')}
        <Icons.Arrow className="transition-all group-hover:translate-x-1" />
      </a>
    </div>
  );
};

const MarkerTooltip = forwardRef<HTMLDivElement, MarkerTooltipType>(
  (props, forwardRef) => {
    const { tooltip } = useAppSelector(selectUiState) || {};

    return (
      <div
        id="tooltip-content"
        className={classNames(
          'bg-white p-4 fixed rounded-md z-[9999] top-0 -translate-x-1/2 translate-y-8 flex-col gap-4 w-[340px]',
          tooltip ? 'flex' : 'hidden',
        )}
        style={{
          top: tooltip?.position?.top,
          left: tooltip?.position?.left,
        }}
        ref={forwardRef}
      >
        <Text
          bold
          color="grey-800"
          elementType="div"
          size="label"
          className="small-caps"
        >
          {tooltip?.content?.title}
        </Text>
        {/* <p className="text-sm">{tooltip?.content?.text}</p> */}
        {/* <RichText text={tooltip?.content.text} /> */}
        dslkfj asdlijvh asdlkjvhsd kjh
      </div>
    );
  },
);

MarkerTooltip.displayName = 'MarkerTooltip';

export default MarkerTooltip;

export { MarkerTooltipFooter };
